module.exports = __webpack_public_path__ + "static/media/timeline-dark.9c9f0aa7.svg";